import React, { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import { Icon } from "../../../../components/icon";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";
import { requestStatusOptions } from "../../../../constants/statusConstants";
import CreateRequestButton from "../../components/CreateRequestButton";
import { AiOutlineFilter } from "react-icons/ai";
import { ExportFileExcel } from "../../info-technology-process/components";
import { compareRequestStatus, getRequestStatusHasAssigneeOptions } from "../../utils";
import moment, { Moment } from "moment";
import { useVehicleRequests } from "./hooks";
import { useVehicleColumn } from "./hooks/use-vehicle-column";
import { Table, UserManual } from "../../../../components";

export const officialVehicleListPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { columns } = useVehicleColumn();
  const { mappedVehicleMyRequests, mappedVehicleRequests = [], isLoading, guideLink } = useVehicleRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedVehicleRequests];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedVehicleRequests]);

  const requestStatusHasAssigneeOptions = getRequestStatusHasAssigneeOptions("Đã cấp mới");

  const flattedData = mappedVehicleRequests.map((record: any) => ({
    createdDateTime: getDDMMYYYFormat(record.createdDateTime),
    eRequestStatus: record.eRequestStatus,
    eRequestPersonName: record.createdByName,
    ePhoneNumber: record.ePhoneNumber,
    eDepartment: record.eDepartment,
    eUnit: record.eUnit,
    eDescription: record.eDescription,
    eRequestStatusText: requestStatusOptions.find((e) => e.value === record.eRequestStatus)?.label,
  }));

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="SỬ DỤNG XE CÔNG VỤ" icon={<Icon.CarCV />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() => history.push(Routes.createOfficialVehiclePage.path.replace(":id", "0"))}
            />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={mappedVehicleMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.officialVehicleDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach yeu cau can duyet su dung xe cong vu",
                content: [
                  { header: "Người yêu cầu", dataIndex: "eRequestPersonName" },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Mô tả", dataIndex: "eDescription" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              initialValues={filters}
              requestStatusOptions={requestStatusHasAssigneeOptions}
              onChange={(_, allValues: any) => setFilters(allValues)}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.officialVehicleDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
